import { createActions } from 'redux-actions';

import { PaymentTransaction } from '@models/PaymentTransaction';
import { CreatePaymentTransactionParams } from '@apis/PaymentTransactionApi';
import { GetBillingParams } from '@apis/BillingApi';
import { Billing } from '@models/Billing';
import { GetCarQuoteParams } from '@apis/CarQuoteApi';
import { CarQuote } from '@models/CarQuote';

export type State = {
  carQuote?: CarQuote | null;
  paymentTransaction?: PaymentTransaction | null;
  billing?: Billing | null;
}

export type CarQuoteFetchPayload = GetCarQuoteParams;
export type BillingFetchPayload = GetBillingParams;
export type PaymentTransactionCreatePayload = CreatePaymentTransactionParams;
export type StateUpdatePayload = Partial<State>;

export const {
  carQuoteFetch,
  billingFetch,
  paymentTransactionCreate,
  stateUpdate,
} = createActions(
  'CAR_QUOTE_FETCH',
  'BILLING_FETCH',
  'PAYMENT_TRANSACTION_CREATE',
  'STATE_UPDATE',
  {
    prefix: 'CAR_QUOTE_PAYMENT_PAGE',
  },
);
